import { useResourceNameModal } from '@hooks/useModal'
import { useUpdateProject } from './useUpdateProject'
import { useTranslation } from 'react-i18next'

export const useRenameProject = () => {
  const { openResourceNameModal } = useResourceNameModal()
  const updateProject = useUpdateProject()
  const { t } = useTranslation()

  const renameProject = (project: AdminProject) => {
    openResourceNameModal({
      title: t('features.projectsAdmin.renameProject'),
      inputLabel: t('features.projectsAdmin.projectName'),
      initialValue: project.name,
      onSave: async (name: string) => {
        await updateProject.mutateAsync({ id: project.id, name })
      },
      toastMessages: {
        success: {
          title: t('features.projectsAdmin.projectSaved'),
          content: (name) => t('features.projectsAdmin.successfullySavedProject', { name }),
        },
        error: {
          title: t('features.projectsAdmin.unableToSaveProject'),
          content: t('features.projectsAdmin.failedToSaveProject', { name: project.name }),
        },
      },
    })
  }

  return { renameProject }
}
